import { render, staticRenderFns } from "./DialogueManage.vue?vue&type=template&id=15fd30ca&scoped=true"
import script from "./DialogueManage.vue?vue&type=script&lang=js"
export * from "./DialogueManage.vue?vue&type=script&lang=js"
import style0 from "./DialogueManage.vue?vue&type=style&index=0&id=15fd30ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fd30ca",
  null
  
)

export default component.exports